import React, { Component } from 'react';
import FontIcon             from 'material-ui/FontIcon';
import FilterItem           from './Filters/FilterItem';
import './../css/App.css';
import './../css/Filters.css';

class Filters extends Component
{
    state = {
        scroll: false
    };

    filterRef = null;

    updateScrollIcon = () =>
    {
        if (null !== this.filterRef)
        {
            let menu = document.getElementById('appFilters');
            if (menu.scrollWidth > menu.offsetWidth && false === this.state.scroll)
            {
                this.setState({scroll: true})
            }
            else if (menu.scrollWidth <= menu.offsetWidth && true === this.state.scroll)
            {
                this.setState({scroll: false})
            }
        }
    };

    componentDidMount = () =>
    {
        window.addEventListener('resize', this.updateScrollIcon);
        this.updateScrollIcon();
    };

    componentDidUpdate = () =>
    {
        this.updateScrollIcon();
    };

    renderRightScroll = () =>
    {
        if (this.state.scroll)
        {
            return (
                <div className="scroll-filters" style={ { backgroundColor: this.props.theme.background } }>
                    <FontIcon color={ this.props.theme.text } className="material-icons filter-scroll-icon">keyboard_arrow_right</FontIcon>
                </div>);
        }
    };

    renderFilters = () => {
        if (null !== this.props.filters)
        {
            return Object.keys(this.props.filters).reduce((result, filterKey) =>
            {
                let filter = this.props.filters[filterKey];
                if (!filter.tag) {
                    const component = <FilterItem
                        key={ filterKey }
                        filterKey={ filterKey }
                        filter={ filter }
                        selected={ (null !== this.props.selected && filter.name === this.props.selected.name) }
                        theme={ this.props.theme }
                        selectFilter={ this.props.selectFilter }
                    />;

                    result.push(component);
                }

                return result;
            }, []);
        }
    };

    render() {
        let filters = this.renderFilters();
        let scroll  = this.renderRightScroll();
        let style   = { };

        if (this.state.scroll)
        {
            style = { paddingRight: 24 }
        }

        return (
            <div ref={ (ref) => { this.filterRef = ref } }>
                <ul id="appFilters" style={ style }>
                        { filters }
                </ul>
                { scroll }
            </div>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Filters.js